<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="25.665" height="18.8" viewBox="0 0 25.665 18.8">
    <g transform="translate(0.6 0.4)">
      <path :style="{stroke:color}" class="a" d="M216.266,54.1h-6a1,1,0,0,0-1,1h0a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1h0A1,1,0,0,0,216.266,54.1Z" transform="translate(-196.601 -50.1)" />
      <path :style="{stroke:color}" class="a" d="M216.266,58.1h-6a1,1,0,0,0-1,1h0a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1h0A1,1,0,0,0,216.266,58.1Z" transform="translate(-196.601 -50.1)" />
      <path :style="{stroke:color}" class="a" d="M216.266,62.1h-6a1,1,0,0,0-1,1h0a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1h0A1,1,0,0,0,216.266,62.1Z" transform="translate(-196.601 -50.1)" />
      <g transform="translate(0)">
        <path :style="{stroke:color}" class="b" d="M208.266,52.1h10a1,1,0,0,1,1,1v12a1,1,0,0,1-1,1h-10a1,1,0,0,1-1-1v-12A1,1,0,0,1,208.266,52.1Zm10-2a3,3,0,0,1,3,3v12a3,3,0,0,1-3,3h-10a3,3,0,0,1-3-3v-12a3,3,0,0,1,3-3Z" transform="translate(-196.601 -50.1)" />
        <g transform="translate(0 4.716)">
          <path class="c" d="M229.93,63.384,225.646,59.1l4.284-4.284" transform="translate(-225.646 -54.816)" />
          <line class="c" x2="9.488" transform="translate(0 4.284)" />
        </g>
      </g>
    </g>
  </svg>
</template>
<script>
export default {
  name: "AssignmentRemoveIcon",
  props: {
    color: String
  }
}

</script>
<style scoped>
.a,
.b {
  fill: #fff;
  stroke: #57b98f;
  stroke-width: 0.8px;
}

.b {
  fill-rule: evenodd;
}

.c {
  fill: none;
  stroke: #fff;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.2px;
}

</style>
